import { FC } from "react";

import LazyImage from "@Components/Image";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

import { CHINA_FOOTER_QR_TILES } from "../../constant";
import classes from "./FooterQRRowChina.module.scss";

const QR_SIZE = 100;

const FooterQRRowChina: FC = () => {
  const { t } = useTranslationHook();

  return (
    <div className={classes.qrRow} data-testid="footer-qr-row-china">
      {CHINA_FOOTER_QR_TILES.map((tile) => (
        <div className={classes.qrTile} key={tile.id}>
          <LazyImage
            dataTestId={`footer-qr-${tile.id}`}
            src={tile.src}
            className={classes.qrImage}
            alt={t(tile.labelKey)}
            width={QR_SIZE}
            height={QR_SIZE}
          />
          <div className={classes.qrLabel}>{t(tile.labelKey)}</div>
        </div>
      ))}
    </div>
  );
};

export default wrapperHOC(FooterQRRowChina, {
  componentName: "FooterQRRowChina-FooterV2",
  showForChina: true,
  showForWhiteLable: false,
  showForMiniProgram: false,
  height: "130px",
});
